import AddShooting from '../views/AddShooting.vue'
import AdminVideo from '../views/AdminVideo.vue'
import Shootings from '../views/Shootings.vue'
import Shooting from '../views/Shooting.vue'
import NotFound from '../views/NotFound.vue'
import Player from '../views/Player.vue'
import LegalNotice from '../views/LegalNotice.vue'
import TermsOfService from '../views/TermsOfService.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import RoomsLive from '../views/RoomsLive.vue'
import LiveVideoCall from '../views/LiveVideoCall.vue'
import Login from '../views/Login.vue'

export default [
  {
    path: '/',
    name: 'home',
    redirect: '/shootings',
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/shootings',
    component: Shootings,
    meta: { requiresAuth: true }
  },
  {
    path: '/shootings/create',
    component: AddShooting,
    meta: { requiresAuth: true }
  },
  {
    path: '/videos/live/rooms',
    component: RoomsLive,
    meta: { requiresAuth: true }
  },
  {
    path: '/videos/live/rooms/:idLiveVideo',
    name: 'LiveVideoCall',
    component: LiveVideoCall
  },
  {
    path: '/adminvideos',
    name: 'AdminVideo',
    component: AdminVideo,
    meta: { requiresAuth: true }
  },
  {
    path: '/owners/:ownerId/products/:productId/shootings/:shootingId',
    component: Shooting,
    meta: { requiresAuth: true }
  },
  {
    path: '/owners/:ownerId/products/:productId/shootings/:shootingId/inspect',
    component: Shooting,
    meta: { requiresAuth: true }
  },
  {
    path: '/owners/:ownerId/products/:productId/shootings/:shootingId/video',
    component: Shooting,
    meta: { requiresAuth: true }
  },
  {
    path: '/owners/:ownerId/products/:productId/shootings/:shootingId/inspection-repair-order',
    component: Shooting,
    meta: { requiresAuth: true }
  },
  {
    name: 'PublicPlayer',
    path: '/public/player/:reference',
    component: Player
  },
  {
    path: '/legal-notice',
    component: LegalNotice
  },
  {
    path: '/terms-of-service',
    component: TermsOfService
  },
  {
    path: '/privacy-policy',
    component: PrivacyPolicy
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/404',
    component: NotFound
  }
]
